import { JSONContent } from '@tiptap/core';

import { extensions } from '@eluve/tiptap-extensions';

import { htmlToMarkdown } from './htmlToMarkdown';
import { tiptapJsonToHtml } from './tiptapJsonToHtml';

type NormalizeMarkdownReturn =
  | { ok: true; result: string }
  | { ok: false; error: Error };

export const tiptapJsonToMarkdown = ({
  jsonContent,
}: {
  jsonContent: JSONContent;
}): NormalizeMarkdownReturn => {
  try {
    const tiptapHtml = tiptapJsonToHtml({
      extensions: extensions,
      json: jsonContent,
    });

    const normalizedHtml = htmlToMarkdown(tiptapHtml);

    return {
      ok: true,
      result: normalizedHtml,
    };
  } catch (error) {
    return {
      ok: false,
      error: error as Error,
    };
  }
};
